import styled from '@emotion/styled'
import {
  Flex,
  FlexItem,
  FormElement,
  InputNumber,
  PANEL_TOGGLE_TITLE_VARIANT_S,
  PanelToggle,
  RadioButton,
  RADIOBUTTON_LABEL_FW_STANDARD,
  SPACING_16,
  SPACING_24,
  SpacingVertical,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_BOLD_LIGHT,
  TEXT_VARIANT_STANDARD
} from 'mailup-web-components'
import {
  contentsState,
  sourceState
} from 'Pages/SourceEdit/recoil/state/source'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue } from 'recoil'

const StyledPanelToggle = styled(PanelToggle)`
  margin-bottom: 8px !important;
`

const UpdateFrequency = () => {
  const intl = useIntl()

  const [
    {
      updateFrequency: {
        frequencyType,
        hoursUpdateFreq,
        minutesUpdateFreq,
        stopUpdate
      }
    },
    setUpdateFrequency
  ] = useRecoilState(sourceState)
  const { totalItems } = useRecoilValue(contentsState)

  const handleOnChangeStandard = () => {
    setUpdateFrequency((prev) => ({
      ...prev,
      updateFrequency: {
        ...prev.updateFrequency,
        frequencyType: 1
      }
    }))
  }

  const handleOnChangeEveryM = () => {
    setUpdateFrequency((prev) => ({
      ...prev,
      updateFrequency: {
        ...prev.updateFrequency,
        frequencyType: 2
      }
    }))
  }

  const handleOnChangeEveryH = () => {
    setUpdateFrequency((prev) => ({
      ...prev,
      updateFrequency: {
        ...prev.updateFrequency,
        frequencyType: 3
      }
    }))
  }

  const handleChangeUpdateStop = (e) => {
    const val = !stopUpdate
    setUpdateFrequency((prev) => ({
      ...prev,
      updateFrequency: {
        ...prev.updateFrequency,
        stopUpdate: val
      }
    }))
  }

  const handleChangeHours = (e) => {
    setUpdateFrequency((prev) => ({
      ...prev,
      updateFrequency: {
        ...prev.updateFrequency,
        hoursUpdateFreq: e
      }
    }))
  }

  const handleChangeMin = (e) => {
    setUpdateFrequency((prev) => ({
      ...prev,
      updateFrequency: {
        ...prev.updateFrequency,
        minutesUpdateFreq: e
      }
    }))
  }

  useEffect(() => {
    if (frequencyType === 0) {
      handleOnChangeStandard()
    }
  }, [frequencyType])

  return (
    <>
      <Text variant={TEXT_VARIANT_BOLD}>
        {intl.formatMessage({ id: 'Load.ContentsSouces.FrequencyUpdate' })}
      </Text>
      <Flex flexDirection='column' margin='16px 0 0 0'>
        <FlexItem>
          <FormElement>
            <RadioButton
              data-mu-test='source-edit__radio-10-min'
              disabled={stopUpdate}
              labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
              label={intl.formatMessage({
                id: 'Load.ContentsSouces.FrequencyUpdateRadioLblStandard'
              })}
              onChange={handleOnChangeStandard}
              checked={frequencyType === 1}
            />
          </FormElement>
        </FlexItem>
        <SpacingVertical variant={SPACING_16} />
        <FlexItem>
          <Flex alignItems='baseline'>
            <FlexItem>
              <RadioButton
                data-mu-test='source-edit__radio-min'
                disabled={stopUpdate}
                labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
                label={intl.formatMessage({ id: 'Load.MailupCommon.Every' })}
                onChange={handleOnChangeEveryM}
                checked={frequencyType === 2}
              />
            </FlexItem>
            <FlexItem>
              <FormElement
                feedback={
                  frequencyType === 2 &&
                  minutesUpdateFreq !== '' &&
                  (minutesUpdateFreq < 11 || minutesUpdateFreq > 59)
                    ? intl.formatMessage({
                        id: 'Load.ContentsSouces.UpdateFreqMinValueNotValid'
                      })
                    : undefined
                }
                variant={
                  frequencyType === 2 &&
                  minutesUpdateFreq !== '' &&
                  (minutesUpdateFreq < 11 || minutesUpdateFreq > 59)
                    ? 'danger'
                    : undefined
                }
              >
                <Flex alignItems='baseline'>
                  <Flex display='block' width='100px'>
                    <InputNumber
                      disabled={stopUpdate || frequencyType !== 2}
                      min={11}
                      max={59}
                      onChange={handleChangeMin}
                      value={minutesUpdateFreq}
                      data-mu-test='source-edit__input-number-min'
                    />
                  </Flex>
                  <FlexItem margin='0 0 0 8px'>
                    <Text
                      variant={
                        stopUpdate
                          ? TEXT_VARIANT_BOLD_LIGHT
                          : TEXT_VARIANT_STANDARD
                      }
                      htmlElement='span'
                    >
                      {intl.formatMessage({ id: 'Load.MailupCommon.Minutes' })}
                    </Text>
                  </FlexItem>
                </Flex>
              </FormElement>
            </FlexItem>
          </Flex>
        </FlexItem>
        <SpacingVertical variant={SPACING_16} />
        <FlexItem>
          <Flex alignItems='baseline'>
            <FlexItem>
              <RadioButton
                data-mu-test='source-edit__radio-hour'
                disabled={stopUpdate}
                labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
                label={intl.formatMessage({ id: 'Load.MailupCommon.Every' })}
                onChange={handleOnChangeEveryH}
                checked={frequencyType === 3}
              />
            </FlexItem>
            <FlexItem>
              <FormElement
                feedback={
                  frequencyType === 3 &&
                  hoursUpdateFreq !== '' &&
                  (hoursUpdateFreq < 1 || hoursUpdateFreq > 24)
                    ? intl.formatMessage({
                        id: 'Load.ContentsSouces.UpdateFreqHourValueNotValid'
                      })
                    : undefined
                }
                variant={
                  frequencyType === 3 &&
                  hoursUpdateFreq !== '' &&
                  (hoursUpdateFreq < 1 || hoursUpdateFreq > 24)
                    ? 'danger'
                    : undefined
                }
              >
                <Flex alignItems='baseline'>
                  <Flex display='block' width='100px'>
                    <InputNumber
                      disabled={stopUpdate || frequencyType !== 3}
                      min={1}
                      max={24}
                      onChange={handleChangeHours}
                      value={hoursUpdateFreq}
                      data-mu-test='source-edit__input-number-hour'
                    />
                  </Flex>
                  <FlexItem margin='0 0 0 8px'>
                    <Text
                      variant={
                        stopUpdate
                          ? TEXT_VARIANT_BOLD_LIGHT
                          : TEXT_VARIANT_STANDARD
                      }
                      htmlElement='span'
                    >
                      {intl.formatMessage({ id: 'Load.MailupCommon.Hours' })}
                    </Text>
                  </FlexItem>
                </Flex>
              </FormElement>
            </FlexItem>
          </Flex>
        </FlexItem>
        {totalItems > 0 && (
          <>
            <SpacingVertical variant={SPACING_24} />
            <StyledPanelToggle
              title={intl.formatMessage({
                id: 'Load.ContentsSouces.StopUpdate'
              })}
              paragraph={intl.formatMessage({
                id: 'Load.ContentsSouces.StopUpdateDescription'
              })}
              titleVariant={PANEL_TOGGLE_TITLE_VARIANT_S}
              onChange={handleChangeUpdateStop}
              checked={stopUpdate}
            />
          </>
        )}
      </Flex>
    </>
  )
}

export default UpdateFrequency
